import React, { useState } from 'react';
import { Modal, Form, Input, DatePicker, Button, Typography, message } from 'antd';
import { CustomerOrder } from '../types';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

interface FulfillOrderModalProps {
  visible: boolean;
  order: CustomerOrder | null;
  onCancel: () => void;
  onConfirm: (fulfillmentData: {
    ddt_number?: string;
    invoice_number?: string;
    invoice_date?: string;
    t1_number?: string;
    t1_date?: string;
  }) => Promise<void>;
  loading?: boolean;
}

const FulfillOrderModal: React.FC<FulfillOrderModalProps> = ({
  visible,
  order,
  onCancel,
  onConfirm,
  loading = false
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      
      // Formatta la data se presente
      const fulfillmentData = {
        ddt_number: values.ddt_number || undefined,
        invoice_number: values.invoice_number || undefined,
        invoice_date: values.invoice_date ? values.invoice_date.format('YYYY-MM-DD') : undefined,
        t1_number: values.t1_number || undefined,
        t1_date: values.t1_date ? values.t1_date.format('YYYY-MM-DD') : undefined
      };

      await onConfirm(fulfillmentData);
      form.resetFields();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={
        <div>
          <Title level={4} style={{ margin: 0 }}>
            Evadi Ordine
          </Title>
          <Text type="secondary">
            {order ? `Ordine ${order.order_number}` : ''}
          </Text>
        </div>
      }
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Annulla
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Evadi Ordine
        </Button>
      ]}
      width={600}
    >
      <div style={{ marginBottom: 16 }}>
        <Text>
          Inserisci le informazioni opzionali di evasione per l'ordine{' '}
          <strong>{order?.order_number}</strong>:
        </Text>
      </div>

      <Form
        form={form}
        layout="vertical"
        name="fulfill-order-form"
      >
        <Form.Item
          label="Numero DDT"
          name="ddt_number"
          rules={[
            {
              max: 50,
              message: 'Il numero DDT non può superare i 50 caratteri'
            }
          ]}
        >
          <Input
            placeholder="Inserisci numero DDT (opzionale)"
            maxLength={50}
          />
        </Form.Item>

        <Form.Item
          label="Numero Fattura"
          name="invoice_number"
          rules={[
            {
              max: 50,
              message: 'Il numero fattura non può superare i 50 caratteri'
            }
          ]}
        >
          <Input
            placeholder="Inserisci numero fattura (opzionale)"
            maxLength={50}
          />
        </Form.Item>

        <Form.Item
          label="Data Fattura"
          name="invoice_date"
        >
          <DatePicker
            placeholder="Seleziona data fattura (opzionale)"
            format="DD/MM/YYYY"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          label="Numero T1"
          name="t1_number"
          rules={[
            {
              max: 50,
              message: 'Il numero T1 non può superare i 50 caratteri'
            }
          ]}
        >
          <Input
            placeholder="Inserisci numero T1 (opzionale)"
            maxLength={50}
          />
        </Form.Item>

        <Form.Item
          label="Data T1"
          name="t1_date"
        >
          <DatePicker
            placeholder="Seleziona data T1 (opzionale)"
            format="DD/MM/YYYY"
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Form>

      <div style={{ 
        marginTop: 16, 
        padding: 12, 
        backgroundColor: '#f6f6f6', 
        borderRadius: 6 
      }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          <strong>Nota:</strong> Tutti i campi sono opzionali. L'ordine verrà marcato come 
          "Evaso" anche se non vengono compilati.
        </Text>
      </div>
    </Modal>
  );
};

export default FulfillOrderModal;